import { Ocorrencias } from "@/paginas/Atividades/CalendarioDeAtividades/CalendarioDeAtividades.modelos"
import { AcumuladorDeFiltrosSelecionados, LegendaDeOcorrencia } from "./filtrosDoCalendario.modelos"
import { ModeloEventoCalendario } from ".."

const codigoOcorrencias = {
  atividadeMuitoLonga: "0000",
  atividadeMuitoCurta: "0001",
  atividadeNaoPlanejada: "0002",
}

export const buscarOcorrenciaSelecionada = (ocorrencias: Ocorrencias): LegendaDeOcorrencia[] | undefined => {
  const chaves: LegendaDeOcorrencia[] = []
  for (const chave in ocorrencias) {
    if (ocorrencias[chave]) {
      chaves.push(chave as LegendaDeOcorrencia)
    }
  }
  return chaves
}

export const filtradorDeAtividades = async (
  atividades: ModeloEventoCalendario[],
  acumuladorDeFiltros: AcumuladorDeFiltrosSelecionados,
  ocorrencias: Ocorrencias
): Promise<ModeloEventoCalendario[]> => {
  const {
    profissional: idFiltrosProfissionais,
    tiposDeAtividade: idFiltrosTiposDeAtividade,
    projeto: idFiltrosProjetos,
  } = acumuladorDeFiltros

  const filtrarPorOcorrencias = (): boolean => {
    return Object.values(ocorrencias).some((ocorrencia) => ocorrencia)
  }

  return new Promise((resolve, reject) => {
    try {
      const atividadesFiltradas = atividades.filter((atividade) => {
        const {
          tipoDeAtividade,
          projeto,
          profissionais,
          problemas,
        } = atividade

        const idTipoDeAtividade = tipoDeAtividade?.id || ''
        const idProjeto = projeto?.id || ''
        const idsProfissionais = profissionais?.map((profissional) => profissional.id) || []

        const possuiProfissional = !idFiltrosProfissionais.length || idsProfissionais.some((id) => idFiltrosProfissionais.includes(id))
        const possuiTipoDeAtividade = !idFiltrosTiposDeAtividade.length || idFiltrosTiposDeAtividade.includes(idTipoDeAtividade)
        const possuiProjeto = !idFiltrosProjetos.length || idFiltrosProjetos.includes(idProjeto)

        if (filtrarPorOcorrencias()) {
          const codigoProblemasAtividade = problemas?.map((problema) => problema.codigo) || []
          const ocorrenciaSelecionada = buscarOcorrenciaSelecionada(ocorrencias) || []

          const ocorrenciasAtividade = ocorrenciaSelecionada.filter((ocorrencia) => {
            const codigoOcorrencia = codigoOcorrencias[ocorrencia]
            return codigoProblemasAtividade.includes(codigoOcorrencia)
          })
          const possuiOcorrencia = ocorrenciasAtividade.length > 0 || (ocorrenciaSelecionada.includes("atividadeSemOcorrencias") && codigoProblemasAtividade.length === 0)

          return (
            possuiProfissional &&
            possuiTipoDeAtividade &&
            possuiProjeto &&
            possuiOcorrencia
          )
        }

        return possuiProfissional && possuiTipoDeAtividade && possuiProjeto
      })

      resolve(atividadesFiltradas)
    } catch (erro) {
      reject(erro)
    }
  })
}
